export default {
    path: ':customer_id/invoices',
    preload: false,
    middlewares: [{
        "rms_ui/validatePermissionsMiddleware": [
            ["invoice.invoice_read"],
            "/"
        ]
    }],
}
